import React from "react"
import { Link } from "gatsby"
import { graphql } from "gatsby"
import { isExternal } from "../utils/url"

const Logo = "/icons/logo_light.svg"

export const query = graphql`
  fragment FooterFields on DatoCmsFooter {
    contactInfo
    columns {
      id
      linksGroup {
        id
        heading
        url
        links {
          id
          title
          url
        }
      }
    }
    bottomLinks {
      id
      title
      url
    }
  }
`

export interface FooterProps extends Queries.FooterFieldsFragment {
  hideNavigation?: boolean
}

const Footer = ({
  hideNavigation,
  contactInfo,
  columns,
  bottomLinks,
}: FooterProps) => {
  return (
    <footer>
      <section className="c-footer">
        <div className="o-wrapper u-flex u-flex-wrap">
          <a className="c-footer__logo" href="/">
            <img src={Logo} alt="Northvolt" />
          </a>
          <div className="c-footer__grid">
            <div className="c-footer__grid__item address">
              {contactInfo && (
                <div
                  className="c-footer__address-container"
                  dangerouslySetInnerHTML={{
                    __html: contactInfo,
                  }}
                />
              )}
              <div className="u-flex c-footer__social">
                <a
                  href="https://twitter.com/northvolt"
                  target="_blank"
                  rel="noreferrer"
                  className="twitter"
                >
                  <span className="is-visually-hidden">Twitter</span>
                </a>
                <a
                  href="https://www.facebook.com/Northvolt/"
                  target="_blank"
                  rel="noreferrer"
                  className="facebook"
                >
                  <span className="is-visually-hidden">Facebook</span>
                </a>
                <a
                  href="https://www.linkedin.com/company/northvolt"
                  target="_blank"
                  rel="noreferrer"
                  className="linkedin"
                >
                  <span className="is-visually-hidden">LinkedIn</span>
                </a>
                <a
                  href="https://www.instagram.com/northvolt/"
                  target="_blank"
                  rel="noreferrer"
                  className="instagram"
                >
                  <span className="is-visually-hidden">Instagram</span>
                </a>
                <a
                  href="https://www.youtube.com/@northvolt5540"
                  target="_blank"
                  rel="noreferrer"
                  className="youtube"
                >
                  <span className="is-visually-hidden">Youtube</span>
                </a>
              </div>
            </div>
            {!hideNavigation &&
              columns &&
              columns.map(column => {
                if (column && column.linksGroup) {
                  return (
                    <div className="c-footer__grid__item" key={column.id}>
                      {column.linksGroup.map(group => {
                        if (group && group.url) {
                          return (
                            <ul className="c-footer__menu" key={group.id}>
                              <li>
                                <Link to={group.url}>{group.heading}</Link>
                              </li>
                              {group.links &&
                                group.links.map(link => {
                                  if (link && link.id && link.url) {
                                    return (
                                      <li key={link.id}>
                                        {isExternal(link.url) ? (
                                          <a href={link.url}>{link.title}</a>
                                        ) : (
                                          <Link to={link.url}>
                                            {link.title}
                                          </Link>
                                        )}
                                      </li>
                                    )
                                  }
                                })}
                            </ul>
                          )
                        }
                      })}
                    </div>
                  )
                }
              })}
          </div>
        </div>
      </section>
      <section className="c-footer__bottom">
        <div className="o-wrapper u-flex">
          <ul>
            <li>&copy; {new Date().getFullYear()} Northvolt AB &nbsp; ⌁</li>
            {bottomLinks &&
              bottomLinks.map(link => {
                if (link && link.url) {
                  return (
                    <li key={link.id}>
                      {isExternal(link.url) ? (
                        <a href={link.url} target="_blank" rel="noreferrer">
                          {link.title}
                        </a>
                      ) : (
                        <Link to={link.url}>{link.title}</Link>
                      )}
                    </li>
                  )
                }
              })}
          </ul>
        </div>
      </section>
    </footer>
  )
}

export default Footer
